__webpack_require__.p = "/org-metrics-dashboard/_next/";